import { useEffect, useState } from "react";
import { ReadQuestionnaire, WriteQuestionnaire } from "@/types/questionnaire";

export const usePersistedQuestionnaireDraft = (
  token: string,
  questionnaireData?: ReadQuestionnaire,
) => {
  const [persistedFormData, setPersistedFormData] =
    useState<WriteQuestionnaire | null>(null);

  useEffect(() => {
    setPersistedFormData(null);
  }, [token, questionnaireData]);

  return { persistedFormData, setPersistedFormData };
};
